import React, { useState } from 'react';
import { Home, X } from 'lucide-react';
export function Footer() {
  const [modalContent, setModalContent] = useState<'privacy' | 'terms' | null>(null);
  return <>
      <footer className="bg-[#0F1C30] py-12 px-6 text-center" data-id="element-78">
        <div className="max-w-4xl mx-auto" data-id="element-79">
          <div className="flex items-center justify-center gap-2 text-white mb-2" data-id="element-80">
            <Home className="w-6 h-6" data-id="element-81" />
            <span className="font-sans font-bold text-xl" data-id="element-82">Calma en Casa</span>
          </div>
          <p className="text-slate-400 text-sm mb-8" data-id="element-83">
            El Sistema CVR para familias reales.
          </p>

          <div className="w-full h-px bg-white/10 mb-8" data-id="element-84" />

          <div className="flex flex-wrap justify-center items-center gap-2 text-sm text-white mb-8" data-id="element-85">
            <button onClick={() => setModalContent('privacy')} className="hover:text-brand-orange underline underline-offset-2 transition-colors" data-id="element-86">
              Política de Privacidad
            </button>
            <span className="text-slate-500" data-id="element-87">·</span>
            <button onClick={() => setModalContent('terms')} className="hover:text-brand-orange underline underline-offset-2 transition-colors" data-id="element-88">
              Términos y Condiciones
            </button>
            <span className="text-slate-500" data-id="element-89">·</span>
            <a href="mailto:contacto@calmaencasa.com" className="hover:text-brand-orange underline underline-offset-2 transition-colors" data-id="element-90">
              Contacto
            </a>
          </div>

          <p className="text-slate-500 text-xs mb-4" data-id="element-91">
            © {new Date().getFullYear()} Calma en Casa. Todos los derechos
            reservados.
          </p>
          <p className="text-slate-500 text-xs max-w-2xl mx-auto" data-id="element-92">
            Este producto es de orientación educativa. No constituye diagnóstico
            médico ni asesoramiento psicológico profesional.
          </p>
        </div>
      </footer>

      {/* Modals */}
      {modalContent && <div className="fixed inset-0 z-50 flex items-center justify-center p-4 bg-brand-navy/80 backdrop-blur-sm" data-id="element-93">
          <div className="bg-white rounded-2xl w-full max-w-lg overflow-hidden shadow-2xl animate-in fade-in zoom-in duration-200" data-id="element-94">
            <div className="p-6 md:p-8" data-id="element-95">
              <div className="flex justify-between items-start mb-6" data-id="element-96">
                <h3 className="font-serif text-2xl text-brand-navy" data-id="element-97">
                  {modalContent === 'privacy' ? 'Política de Privacidad' : 'Términos y Condiciones'}
                </h3>
                <button onClick={() => setModalContent(null)} className="p-1 text-slate-400 hover:text-brand-navy transition-colors" data-id="element-98">
                  <X className="w-6 h-6" data-id="element-99" />
                </button>
              </div>

              <div className="prose prose-sm text-slate-600 max-h-[60vh] overflow-y-auto pr-2" data-id="element-100">
                {modalContent === 'privacy' ? <>
                    <p className="font-bold mb-4" data-id="element-101">
                      Política de Privacidad — Calma en Casa
                    </p>
                    <p className="mb-4" data-id="element-102">
                      En Calma en Casa respetamos tu privacidad. Los datos que
                      recopilamos (nombre y correo electrónico) se utilizan
                      únicamente para enviarte el acceso a tu compra y
                      comunicaciones relacionadas con el producto.
                    </p>
                    <p className="mb-4" data-id="element-103">
                      No vendemos ni compartimos tu información con terceros.
                      Puedes solicitar la eliminación de tus datos en cualquier
                      momento enviando un correo a: contacto@calmaencasa.com
                    </p>
                    <p className="text-sm text-slate-400 mt-8" data-id="element-104">
                      Última actualización: Mayo 2026.
                    </p>
                  </> : <>
                    <p className="font-bold mb-4" data-id="element-105">
                      Términos y Condiciones — Calma en Casa
                    </p>
                    <p className="mb-4" data-id="element-106">
                      Al adquirir este producto aceptas que:
                    </p>
                    <ol className="list-decimal pl-5 space-y-2 mb-4" data-id="element-107">
                      <li data-id="element-108">
                        El contenido es de uso personal y no puede ser
                        redistribuido.
                      </li>
                      <li data-id="element-109">
                        Este producto es una guía educativa y no reemplaza el
                        diagnóstico o tratamiento médico o psicológico.
                      </li>
                      <li data-id="element-110">
                        La garantía de 7 días aplica enviando un correo a
                        contacto@calmaencasa.com dentro del período indicado.
                      </li>
                      <li data-id="element-111">
                        El acceso es inmediato y de por vida en la plataforma
                        Hotmart.
                      </li>
                    </ol>
                    <p className="text-sm text-slate-400 mt-8" data-id="element-112">
                      Última actualización: Mayo 2026.
                    </p>
                  </>}
              </div>

              <div className="mt-8 pt-6 border-t border-slate-100 text-right" data-id="element-113">
                <button onClick={() => setModalContent(null)} className="px-6 py-2 bg-slate-100 hover:bg-slate-200 text-brand-navy font-medium rounded-lg transition-colors" data-id="element-114">
                  Cerrar
                </button>
              </div>
            </div>
          </div>
        </div>}
    </>;
}